import * as React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@spaced-out/ui-lib/lib/button'. '/Users/diwaker/SpacedOut/ui-server/node_modules/@spaced-out/ui-lib/lib/button/index.js' implicitly has an 'any' type.
import {UnstyledButton} from '@spaced-out/ui-lib/lib/button';

import classify from 'src/utils/classify';

import css from './walkme-button.css';


export default function WalkmeButton({className}: {className?: string}) {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  // @ts-expect-error - TS7030 - Not all code paths return a value.
  React.useEffect(() => {
    // @ts-expect-error - TS2339 - Property 'WalkMePlayerAPI' does not exist on type 'Window & typeof globalThis'.
    if (window.WalkMePlayerAPI) {
      setIsLoaded(true);
    } else {
      // @ts-expect-error - TS2339 - Property 'walkme_ready' does not exist on type 'Window & typeof globalThis'.
      window.walkme_ready = () => {
        setIsLoaded(true);
      };

      return () => {
        // @ts-expect-error - TS2339 - Property 'walkme_ready' does not exist on type 'Window & typeof globalThis'.
        window.walkme_ready = null;
      };
    }
  }, []);

  // @ts-expect-error - TS7030 - Not all code paths return a value.
  React.useEffect(() => {
    if (isLoaded) {
      const callback = () => {
        // NOTE (kyle): we don't care which player event this actually is.
        // @ts-expect-error - TS2339 - Property 'WalkMePlayerAPI' does not exist on type 'Window & typeof globalThis'.
        setIsMenuOpen(window.WalkMePlayerAPI.isMenuOpen());
      };
      callback();
      // @ts-expect-error - TS2339 - Property 'walkme_player_event' does not exist on type 'Window & typeof globalThis'.
      window.walkme_player_event = callback;
      return () => {
        // @ts-expect-error - TS2339 - Property 'walkme_player_event' does not exist on type 'Window & typeof globalThis'.
        window.walkme_player_event = null;
      };
    }
  }, [isLoaded]);

  return (
    isLoaded &&
    !isMenuOpen && (
      <UnstyledButton
        className={classify(className, css.button)}
        onClick={() => {
          // @ts-expect-error - TS2339 - Property 'WalkMePlayerAPI' does not exist on type 'Window & typeof globalThis'.
          window.WalkMePlayerAPI.toggleMenu();
        }}
      >
        Sense Support
      </UnstyledButton>
    )
  );
}
